"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EnterDirective = exports.EnterDirective = function () {
  function EnterDirective() {
    _classCallCheck(this, EnterDirective);
  }

  _createClass(EnterDirective, [{
    key: "link",
    value: function link(scope, element, attrs) {
      element.bind("keydown keypress", function (event) {
        var code = event.keyCode || event.which;
        if (code === 13) {
          event.preventDefault();
          scope.$apply(function () {
            return scope.$eval(attrs.fEnter);
          });
        }
      });
    }
  }]);

  return EnterDirective;
}();


//////////////////
// WEBPACK FOOTER
// ./common/directives/f-enter/enter.dir.js
// module id = 472
// module chunks = 0